export default __webpack_public_path__ + "static/media/type-public.3f1ac627.svg";